import TrainsSearchFormBaseController from '../../trains-base/controllers/trains-search-form-base-controller';

export default function TrainsSearchFormController(
    $scope,
    $controller,
    settingsCabinClasses,
    trainsFactory,
    l10nService,
    timeSlots
) {
    'ngInject';

    $scope.locationPlaceholder = l10nService.localize('City, train station...');
    $scope.moreOptionsTemplate = 'app/modules/train/directives/templates/moreOptions.tmpl.html';
    $scope.travellersTemplate = 'app/modules/train/directives/templates/travellers.tmpl.html';

    $controller(TrainsSearchFormBaseController, {
        $scope,
        trainsFactory,
        settingsCabinClasses,
        settingsAirlines: [],
        timeSlots,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-search-form-controller.js